import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';

import {FleetChecklistType, FleetChecklist, FleetStatus} from '../models/fleet-checklist';
import {VehicleValidation, SelectableVehicle} from '../models/vehicle-validation';

import { FleetChecklistApiService } from './fleet-checklist-api.service';

import {VehicleValidationManagerService} from './vehicle-validation-manager.service';

import {FleetChecklistHelper} from '../helpers/fleet-checklist.helper';
import { DynamicFiledSelected } from '../models/dynamic-field';

@Injectable({
  providedIn: 'root'
})
export class FleetChecklistBulkEditorService {
  private uploadImageModalOpenSubject = new BehaviorSubject<boolean>(false);
  uploadImageModalOpen$ = this.uploadImageModalOpenSubject.asObservable();

  private fb = inject(FormBuilder);

  uploadImageform = this.fb.group({
    name: ['', Validators.required],
    file: [null, Validators.required],
  });

  constructor(
    private api: FleetChecklistApiService,
    private vehicleValidation: VehicleValidationManagerService
  ) { }

  // MODALS
  openUploadImageModal() {
    // this.uploadImageform.reset();
    this.loadFormDefaults();
    this.uploadImageModalOpenSubject.next(true);
  }
  closeModals() {
    this.uploadImageModalOpenSubject.next(false);
  }

  // FORM
  loadFormDefaults(): void {
    this.uploadImageform.patchValue({
      name: 'VALIDACION DE EQUIPOS DE UNIDADES EXTERNAS',
      file: null
    });
  }
  isFormValid(): boolean {
    return this.uploadImageform.valid;
  }
  resetForm() {
    this.uploadImageform.reset();
  }

  async onUploadImageFormSubmit() : Promise<FleetChecklist[] | null> {
    const typeValidation = FleetChecklistType.EXTERNO;
    if (this.uploadImageform.invalid) {
      this.uploadImageform.markAllAsTouched();
      return null;
    }
    let file = this.uploadImageform.get('file')?.value;
    let name = this.uploadImageform.get('name')?.value;
    let res = await this.api.extractConvoystFromImage(file);

    if(!res) return null
    let metadata = res.metadata;
    let convoyes = res.convoyes;
    let newChecklists : FleetChecklist[] = [];

    convoyes.forEach((convoy) => {
      const vehicles = convoy.vehicles
        .map((vehicleConvoy) => {
          const vehicle = this.vehicleValidation.findVehicleByPlate(
            vehicleConvoy.vehiclePlate
          );

          if (!vehicle?.id) {
            return null;
          }

          vehicleConvoy.vehicle_id = vehicle.id;

          return vehicle;
        })
        .filter(Boolean) as SelectableVehicle[];

      const fechaProgramacion = metadata?.fecha_programacion?.replaceAll('.', '-');

      let fleetType = FleetChecklistHelper.getFleetType(typeValidation);

      let tags = [fleetType, ...convoy.times, ...convoy.tags];

      convoy.toCreate = {
        name: `${name}`,
        status: FleetStatus.IN_PROGRESS,
        tags,
        type: typeValidation,
        fields: FleetChecklistHelper.getFieldsDynamicByType(typeValidation),
        vehiclesIds: vehicles.map((v) => v.id.toString()),
        parameters: {
          validationDate: fechaProgramacion
        }
      };
    });

    for (const c of convoyes) {
      if(!c.toCreate) continue
      let newFleet = await this.api.createFleetChecklist(c.toCreate);
      console.log('Checklist Bulk Editor: createFleetChecklist', newFleet)
      if(!newFleet) continue
      newChecklists.push(newFleet)
      let vehicleValidation : VehicleValidation[] = newFleet?.vehicles.map(v => {
        let vehicleConvoy = c.vehicles.find(cv => cv.vehicle_id === Number(v.id) || cv.vehiclePlate === v.plate);
        let defaultFields = vehicleConvoy ? FleetChecklistHelper.getDefaultConvoyFields(vehicleConvoy) : [];
        const dynamicFields: Record<string, DynamicFiledSelected> = {};

        defaultFields.forEach(field => {
          dynamicFields[field.id] = field;
        });

        return {
          ...v,
          fields: dynamicFields,
          modified: true
        }
      })
      console.log('Checklist Bulk Editor: updateFleetVehiclesValidation', vehicleValidation)
      this.api.updateFleetVehiclesValidation(newFleet?.id || '', vehicleValidation || []);
    }
    return newChecklists
  }
  setFile(file: File) {
    this.uploadImageform.get('file')?.setValue(file);
  }
  removeFile(): void {
    this.uploadImageform.get('file')?.setValue(null);
  }

}
